/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var parsleyUtil = require('common/util/parsleyUtil');

var tmplCollectorRepossessorRenewalContractsSectionView = require('./CollectorRepossessorRenewalContractsSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCollectorRepossessorRenewalContractsSectionView,

  className: 'collector-repossessor-renewal-contract-section-view',

  ui: {
    contractsForm: '.contracts-form'
  },

  behaviors: {
    RadioGroupToggleBehavior: {
      radios: [
        {
          target: '#hasCollectedMoniesArea',
          radioGroup: '[name="hasCollectedMonies"]',
          valueToShow: '1'
        },
        {
          target: '#reportingZeroReasonArea',
          radioGroup: '[name="hasCollectedMonies"]',
          valueToShow: '0'
        },
        {
          target: '#reportingRepossessArea',
          radioGroup: '[name="hasRepossessMotorVehicles"]',
          valueToShow: '1'
        },
        {
          target: '#reportingNoRepossessArea',
          radioGroup: '[name="hasRepossessMotorVehicles"]',
          valueToShow: '0'
        }
      ]
    }
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.get('renewalData'));
  },

  validate: function(config) {
    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.contractsForm);
    } else {
      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.contractsForm);
    }
    return this.ui.contractsForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    return formData;
  }
});
